import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { DeviceDetectService } from "../../services/device-detect.service";

/** Redirects desktop users away from mobile-only routes (e.g. /more). */
@Injectable({ providedIn: "root" })
export class MobileOnlyGuard implements CanActivate {
  constructor(
    private deviceDetect: DeviceDetectService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.deviceDetect.isMobile) {
      return true;
    }
    this.router.navigate(["/"]);
    return false;
  }
}
